<template>
  <div class="fullname">
    <div class="fullname_top">
      <van-icon style="position: absolute; left: 10px" size="25" name="arrow-left" @click="to()" />
      <div class="my">毕业院校</div>
      <div class="determine" @click="determine">确定</div>
    </div>
    <div class="fullname_bottm">
      <van-cell-group style="border-radius: 8px">
        <van-field v-model="school" placeholder="请输入毕业院校" maxlength="20" ref="input">
          <template #button>
            <van-button size="small" style="border: none">{{ school.length }}/20</van-button>
          </template></van-field>
      </van-cell-group>
    </div>
  </div>
</template>
  
<script>
export default {
  name: "fullname",
  data() {
    return {
      disabled: false,
      school: "",
      obj: {},
    };
  },
  created() {
    // 回显
    if (JSON.parse(sessionStorage.getItem("scholarUserInfos"))) {
      this.school = JSON.parse(
        sessionStorage.getItem("scholarUserInfos")
      ).userInfo.school;
      this.obj = JSON.parse(sessionStorage.getItem("scholarUserInfos"));
    } else {
      this.school = JSON.parse(
        sessionStorage.getItem("scholarUserInfo")
      ).userInfo.school;

      this.obj = JSON.parse(sessionStorage.getItem("scholarUserInfo"));
    }
    // 聚焦
    this.$nextTick(() => {
      this.$refs.input.focus();
    });
  },
  methods: {
    to() {
      window.history.go(-1);
    },
    determine() {
      if (this.school.length == 0) {
        Toast("不能为空");
      } else {
        this.obj.userInfo.school = this.school;

        sessionStorage.setItem("scholarUserInfos", JSON.stringify(this.obj));

        this.$router.push("information");
      }
    },
  },
};
</script>
  
<style lang="scss" scoped>
.fullname {
  width: 100vw;
  min-height: 100vh;
  overflow: hidden;
  background: #f5f5f5;

  .fullname_top {
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    line-height: 44px;
    align-content: center;
    position: relative;

    .my {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      background: #fff;
      text-align: center;
    }

    .determine {
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      position: absolute;
      right: 15px;
    }
  }

  .fullname_bottm {
    width: 94%;
    margin: 12px auto;
    background: #fff;
    border-radius: 8px;

    .van-field {
      border-radius: 8px;
    }
  }
}
</style>